import { useCallback, useContext, useState } from 'react'
import { downloadFromStorage } from '../../backend/storage'
import { PopUpMessageContext } from '../../contexts/PopUpMessage/PopUpMessageContext'
import { usePdfView } from './context'

export const usePdfDownload = () => {
  const { document } = usePdfView()
  const [downloadLoading, setDownloadLoading] = useState(false)

  const { showMessage } = useContext(PopUpMessageContext)
  const onDownload = useCallback(async () => {
    try {
      const { signedStoragePath } = document ?? {}
      if (!signedStoragePath) {
        throw new Error('No signed storage path')
      }
      setDownloadLoading(true)
      await downloadFromStorage(signedStoragePath)
      showMessage({
        type: 'success',
        text: 'Signed PDF downloaded',
      })
    } catch (err) {
      console.error(err)
      showMessage({
        type: 'error',
        text: 'Unable to download signed PDF',
        subText: 'Please contact support',
      })
    } finally {
      setDownloadLoading(false)
    }
  }, [document, showMessage])
  return {
    downloadLoading,
    setDownloadLoading,
    onDownload,
  }
}
